import { render, staticRenderFns } from "./BwShareButton.vue?vue&type=template&id=5cafaa68"
import script from "./BwShareButton.vue?vue&type=script&lang=js"
export * from "./BwShareButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports